export enum TransactionType {
  BUY = 'BUY',
  SELL = 'SELL'
}
